<template>
  <section class="pt-[60px] xl:pt-[140px]">
    <div class="container">
      <SectionTitle
        title-class="!mb-0"
        :title="$t('landing.info.title')"
        class="mx-auto text-center xl:mb-14 mb-8"
      >
        <p
          class="text-dark text-base max-w-[800px] mx-auto"
          v-html="$t('landing.info.description')"
        />
      </SectionTitle>
      <div class="w-full grid grid-cols-2 md:grid-cols-4 gap-10">
        <Info
          v-for="(info, idx) of infoStatistics"
          :key="idx"
          :value="info?.value"
          :title="$t(info?.title)"
        />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import SectionTitle from "@/modules/Landing/components/Common/SectionTitle.vue";
import Info from "@/modules/Landing/components/Card/Info.vue";

import { infoStatistics } from "@/data/index";
</script>

<style scoped></style>
